module.exports = "<div id=\"video-chat-confirm-leave-modal\"></div> ";